const isBrowser = () => {
  return typeof window !== "undefined";
};

export { isBrowser };
//# sourceMappingURL=isBrowser.mjs.map
